import axios from "axios";

export interface CtaVersionType {
  versionIdentifier: string;
  content?: any;
}

export function applyFirstEditionDefaults(
  versionIdentifier: string | undefined,
  expectedPrefix: string,
  defaults: Record<string, any>,
  ctaContent?: Record<string, any>
): Record<string, any> {
  if (
    versionIdentifier === expectedPrefix ||
    versionIdentifier === `${expectedPrefix} v1`
  ) {
    const filteredContent = Object.fromEntries(
      Object.entries(ctaContent || {}).filter(([key, value]) => value !== "")
    );
    return { ...defaults, ...filteredContent };
  }
  return ctaContent || {};
}

export async function fetchCtaVersions(
  widgetLabel: string,
  desiredPrefix?: string
): Promise<CtaVersionType | null> {
  try {
    const url = `${process.env.NEXT_PUBLIC_API_URL}/cta/${encodeURIComponent(
      widgetLabel
    )}`;
    const response = await axios.get(url, { withCredentials: true });

    if (response.status !== 200) {
      console.error(`Failed to fetch CTA versions: HTTP ${response.status}`);
      return null;
    }

    const data = response.data;

    let ctas: any[] = [];
    if (Array.isArray(data)) {
      ctas = data;
    } else if (data && data.versionIdentifier) {
      ctas = [data];
    } else {
      console.error("No valid CTA data found");
      return null;
    }

    if (desiredPrefix) {
      const upperPrefix = desiredPrefix.toUpperCase();
      const filtered = ctas.filter(
        (item) =>
          typeof item.versionIdentifier === "string" &&
          item.versionIdentifier.toUpperCase().startsWith(upperPrefix)
      );
      if (filtered.length > 0) {
        ctas = filtered;
      }
    }

    if (ctas.length === 0) {
      console.error("No CTA version found after prefix filtering");
      return null;
    }

    const randomIndex = Math.floor(Math.random() * ctas.length);
    const chosen = ctas[randomIndex];
    return {
      versionIdentifier: chosen.versionIdentifier,
      content: chosen.content,
    };
  } catch (error) {
    console.error("Failed to fetch CTA versions:", error);
    return null;
  }
}

export async function postCtaView(
  widgetLabel: string,
  versionIdentifier: string
): Promise<void> {
  try {
    await axios.post(
      `${process.env.NEXT_PUBLIC_API_URL}/cta/view`,
      { widgetLabel, versionIdentifier },
      { withCredentials: true }
    );
  } catch (error) {
    console.error("Error posting CTA view:", error);
  }
}

export async function postCtaConversion(
  widgetLabel: string,
  versionIdentifier: string
): Promise<void> {
  try {
    await axios.post(
      `${process.env.NEXT_PUBLIC_API_URL}/cta/conversion`,
      { widgetLabel, versionIdentifier },
      { withCredentials: true }
    );
  } catch (error) {
    console.error("Error posting CTA conversion:", error);
  }
}
//
